var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "mainCreditEvaluationRef" } },
    [
      _c("div", { staticClass: "top_line" }, [
        _c("span", { staticClass: "mainName" }, [
          _vm._v(
            _vm._s(
              _vm.dataObj
                ? _vm.dataObj.chapter1
                  ? _vm.dataObj.chapter1.baseInfo.mainName
                  : "--"
                : "--"
            )
          ),
        ]),
      ]),
      _c("el-card", { staticClass: "box-card creditEvaluation" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [_c("span", [_vm._v("交易主体信用评价信息")])]
        ),
        _c("div", { staticClass: "card-item" }, [
          _c(
            "div",
            { staticClass: "card-content" },
            [
              _c("div", [_vm._v("信用评价：")]),
              _c("creditEvaluation", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
              _c("div", [_vm._v("诉讼及仲裁情况：")]),
              _c("litigationArbitration", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
              _c("div", [_vm._v("信息披露：")]),
              _c("disclosureList", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
              _c("div", [_vm._v("其他投标证明材料：")]),
              _c("otherBidFilesList", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
              _c("div", [_vm._v("其他银行账户信息：")]),
              _c("otherBankInfoList", {
                attrs: {
                  entStatus: _vm.entStatusCopy,
                  pageStatus: _vm.pageStatusCopy,
                },
                on: {
                  "update:entStatus": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:ent-status": function ($event) {
                    _vm.entStatusCopy = $event
                  },
                  "update:pageStatus": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                  "update:page-status": function ($event) {
                    _vm.pageStatusCopy = $event
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }